import React, { useState, useEffect, useRef, memo, useMemo } from "react";
import moment from "moment";
import { BiDotsVerticalRounded } from "react-icons/bi";
import { IoChatbox } from "react-icons/io5";
import { useSelector } from "react-redux";
import { DEFAULTIMAGEURL, IMAGEURL } from "../Utils/EndPoint";

const LeftSide = memo(({ toggleModal, chatList, handleSelectChat, clearConversation }) => {
  const [dropdownOpenId, setDropdownOpenId] = useState(null);
  const dropdownRef = useRef(null);
  const processedChatList = useMemo(
    () =>
      chatList.map((chat) => ({
        ...chat,
        displayName: `${chat.otherUser.firstName} ${chat.otherUser.lastName}`,
      })),
    [chatList]
  );

  const toggleDropdown = (id) => {
    setDropdownOpenId((prevId) => (prevId === id ? null : id));
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setDropdownOpenId(null);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="flex justify-between items-center p-4 border-b bg-gray-100">
        <h2 className="text-lg font-bold text-gray-900">My Chat</h2>
        <IoChatbox
          onClick={toggleModal}
          className="text-gray-500 cursor-pointer hover:text-gray-700"
          size={20}
        />
      </div>
    

      {processedChatList.length > 0 ? (
        processedChatList.map((chat) => (
          <div
            key={chat._id}
            className="flex items-center gap-3 p-2 border-b border-gray-200 hover:bg-gray-100 transition "
          >
            <div
              onClick={() => handleSelectChat(chat)}
              className="flex items-center flex-grow gap-3 cursor-pointer"
            >
              <img
                src={chat.otherUser.image ? `${IMAGEURL}/${chat.otherUser.image}` : DEFAULTIMAGEURL }
                alt={`${chat.displayName}'s profile`}
                className="w-10 h-10 rounded-full object-cover"
              />
              <div className="flex flex-col">
                <span className="font-medium text-gray-900">{chat.displayName}</span>
                <span className="text-sm text-gray-500 line-clamp-1 ">{chat.chat}</span>
              </div>
            </div>
            <div className="text-sm text-gray-400 min-w-[130px]">{moment(chat.updatedAt).format("DD-MM-YY h:mm A")}</div>
            <BiDotsVerticalRounded
              onClick={(e) => {
                e.stopPropagation();
                toggleDropdown(chat._id);
              }}
              className="text-gray-500 cursor-pointer min-w-4 hover:text-gray-700"
              size={20}
            />
            {dropdownOpenId === chat._id && (
              <div
                ref={dropdownRef}
                className="absolute right-0 mt-16 w-30 bg-white border rounded shadow-lg z-20"
              >
                <button
                  className="block w-full text-left px-4 py-2 hover:bg-gray-100 cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    setDropdownOpenId(null);
                    clearConversation(chat);
                  }}
                >
                  Clear Conversation
                </button>
              </div>
            )}
          </div>
        ))
      ) : (
        <div className="h-full text-black flex justify-center items-center font-semibold">
          <h1>Select a new chat to start chatting</h1>
        </div>
      )}
    </>
  );
});

export default LeftSide;
